export default {"src":"/_next/static/media/sync_vs.411313f5.svg","height":23,"width":17,"blurWidth":0,"blurHeight":0};